// 120 inspiration lines for the personal welcome screen (2026-10-16), one list per language the
// client app supports. Index N in Hebrew and English carries the same idea. The server only
// stores which index each customer sees next (welcomeRotationService); the texts live here, so
// no AI call or download happens at sign-in. Keep exactly 120 entries in each language.

export const GREETINGS = {
  he: [
    'מה נבנה היום?',
    'איזה רעיון נהפוך היום למציאות?',
    'מה תרצו ליצור היום?',
    'איזה פרויקט חדש נתחיל?',
    'יש רעיון חדש באוויר?',
    'מה ניצור יחד היום?',
    'מוכנים לבנות משהו חדש?',
    'איזו אפליקציה ניצור הפעם?',
    'איזה אתר נעלה לאוויר היום?',
    'ספרו לי על הרעיון, ואני אדאג לשאר.',
    'מאיפה נתחיל היום?',
    'איזה עסק נקדם היום ברשת?',
    'על מה חלמתם לבנות?',
    'בואו נהפוך רעיון לאתר עובד.',
    'מה הצעד הבא בפרויקט שלכם?',
    'איזו חוויה דיגיטלית נעצב היום?',
    'מה הלקוחות שלכם צריכים לראות?',
    'יש לכם עסק? בואו נבנה לו בית ברשת.',
    'איזה כלי יחסוך לכם זמן?',
    'נתחיל מדף נחיתה או מאפליקציה?',
    'מה עוד חסר לעסק שלכם באונליין?',
    'רעיון קטן יכול להפוך לאפליקציה גדולה. מה שלכם?',
    'תארו לי מה אתם רואים בדמיון.',
    'איזה מוצר נשיק היום?',
    'מה נשדרג היום?',
    'איזו חנות אונליין נפתח?',
    'בואו נבנה משהו שאנשים יאהבו.',
    'איזו בעיה האפליקציה שלכם תפתור?',
    'תנו לי משפט אחד, ואני אתחיל לבנות.',
    'איזה עמוד יעשה רושם ראשון מושלם?',
    'מה נצייר היום בקוד?',
    'יש רעיון שמחכה כבר הרבה זמן?',
    'בואו נגרום לרעיון שלכם לעבוד.',
    'איזה טופס, תור או הזמנה נאפשר ללקוחות?',
    'מה תרצו שהאתר יעשה בשבילכם?',
    'איזה סיפור העסק שלכם מספר?',
    'מוכנים להפתיע את הלקוחות?',
    'איך נגיע היום ליותר אנשים?',
    'מה נבנה מאפס הפעם?',
    'איזה רעיון ראוי לקבל אפליקציה משלו?',
    'בואו ניצור אתר שעובד בשבילכם גם בלילה.',
    'מה יהפוך את היום הזה לפרודוקטיבי?',
    'איזה תפריט, קטלוג או גלריה נבנה?',
    'ספרו לי על העסק, ונבנה לו אתר.',
    'איזו אפליקציה תרצו בטלפון שלכם?',
    'מה חסר לכם בעולם, שנבנה עכשיו?',
    'בואו נתחיל משהו מרגש.',
    'איזה פרויקט צד נוציא לפועל?',
    'מה הדבר הבא שתשיקו?',
    'כתבו מה אתם צריכים — אני כבר אבנה.',
    'איזה רעיון לא נותן לכם מנוחה?',
    'מה נבנה לעסק שלכם הפעם?',
    'נבנה אתר תדמית, חנות או מערכת?',
    'איך נראית האפליקציה החלומית שלכם?',
    'מה נוסיף היום לפרויקט?',
    'בואו נעשה את זה פשוט: מה תרצו לבנות?',
    'איזה עיצוב ישקף את המותג שלכם?',
    'מה הלקוחות שלכם מחפשים?',
    'איזה רעיון נבדוק היום?',
    'מה ייראה מדהים גם בטלפון?',
    'יש לכם תמונה או סקיצה? אפשר להתחיל ממנה.',
    'על איזה פרויקט נעבוד יחד?',
    'מה תרצו להראות לעולם?',
    'בואו נבנה את הגרסה הראשונה.',
    'איזה רעיון יהפוך לפרויקט של השבוע?',
    'מה יעזור לכם למכור יותר?',
    'איזה דף יציג את השירותים שלכם הכי טוב?',
    'מה נלמד את האפליקציה לעשות?',
    'איזו מערכת תסדר לכם את העבודה?',
    'בואו נצא לדרך. מה המטרה?',
    'מה תרצו שאנשים ירגישו כשהם נכנסים לאתר?',
    'באיזה תחום נבנה היום?',
    'מה נבנה לקהילה שלכם?',
    'איזה אירוע, קורס או סדנה נקדם?',
    'מה תרצו שיקרה אוטומטית?',
    'איזה פיצ׳ר חדש נבנה?',
    'מה יהיה הפרויקט הבא שלכם?',
    'בואו נבנה משהו שעוד לא היה.',
    'מה השם של הרעיון הבא שלכם?',
    'איך נהפוך את העסק שלכם לדיגיטלי?',
    'איזה לוח בקרה יעשה לכם סדר?',
    'מה נבנה בשביל הלקוחות שלכם?',
    'יש לכם כמה דקות? זה מספיק כדי להתחיל.',
    'מה הייתם בונים אם הכול היה אפשרי?',
    'מה האתר שלכם צריך לומר במבט ראשון?',
    'איזו אפליקציה תחסוך לכם שיחות טלפון?',
    'בואו נגרום לעסק שלכם לבלוט.',
    'מה נכין להשקה הבאה?',
    'איזה מוצר דיגיטלי נבנה?',
    'מה תרצו לבנות לפני סוף היום?',
    'איפה הרעיון שלכם יפגוש את הלקוחות?',
    'איזה חלום עסקי נקדם היום?',
    'מה נשפר באתר הקיים?',
    'בואו נבנה משהו מהיר, יפה ושימושי.',
    'על איזו שאלה האפליקציה שלכם תענה?',
    'מה תרצו שהלקוחות יוכלו לעשות בלחיצה?',
    'איזה רעיון נלביש בעיצוב חדש?',
    'מה הפרויקט שתמיד רציתם לבנות?',
    'איזה שירות נציג היום ברשת?',
    'מתחילים? ספרו לי מה בונים.',
    'איזה תיק עבודות נבנה לכם?',
    'מה יגרום ללקוחות לחזור?',
    'איזו אפליקציה תעשה לכם את היום קל יותר?',
    'מה נבנה לצוות שלכם?',
    'בואו נהפוך את הרעיון לקליק.',
    'איזה אתר יגרום לכם להתגאות?',
    'מה תרצו לבדוק בשטח?',
    'איזה פרויקט נוציא היום מהמגירה?',
    'מה נבנה עבור המותג שלכם?',
    'איזה מסך ראשון יפגוש את המשתמשים?',
    'מה הדבר הכי חשוב שהאתר צריך לעשות?',
    'איזה תהליך נהפוך לאוטומטי?',
    'בואו נבנה יחד, צעד אחר צעד.',
    'מה תרצו להשיק החודש?',
    'איזו רשימה, לוח או יומן נבנה?',
    'מה נבנה עבור הלקוח הבא שלכם?',
    'איזה רעיון יתחיל את השבוע בתנופה?',
    'מה תרצו שהטלפון שלכם יוכל לעשות?',
    'בואו נבנה משהו שיעבוד מהיום הראשון.',
    'יש לכם חזון? בואו נבנה אותו.'
  ],
  en: [
    'What shall we build today?',
    'Which idea are we bringing to life today?',
    'What would you like to create today?',
    'What new project shall we start?',
    'Got a new idea in the air?',
    'What are we creating together today?',
    'Ready to build something new?',
    'Which app are we making this time?',
    'Which website are we launching today?',
    'Tell me the idea, and I will take care of the rest.',
    'Where shall we start today?',
    'Which business are we growing online today?',
    'What have you been dreaming of building?',
    'Let us turn an idea into a working website.',
    'What is the next step in your project?',
    'Which digital experience are we designing today?',
    'What do your customers need to see?',
    'Have a business? Let us give it a home online.',
    'Which tool would save you time?',
    'Shall we start with a landing page or an app?',
    'What is your business still missing online?',
    'A small idea can become a big app. What is yours?',
    'Describe what you picture in your mind.',
    'Which product are we launching today?',
    'What are we upgrading today?',
    'Which online store are we opening?',
    'Let us build something people will love.',
    'Which problem will your app solve?',
    'Give me one sentence, and I will start building.',
    'Which page will make the perfect first impression?',
    'What shall we draw in code today?',
    'Is there an idea that has been waiting a long time?',
    'Let us make your idea work.',
    'Which form, booking or order shall we offer customers?',
    'What would you like the website to do for you?',
    'What story does your business tell?',
    'Ready to surprise your customers?',
    'How do we reach more people today?',
    'What are we building from scratch this time?',
    'Which idea deserves an app of its own?',
    'Let us create a website that works for you even at night.',
    'What would make today productive?',
    'Which menu, catalog or gallery shall we build?',
    'Tell me about the business, and we will build it a website.',
    'Which app would you like on your phone?',
    'What is missing in the world that we can build now?',
    'Let us start something exciting.',
    'Which side project are we making real?',
    'What is the next thing you will launch?',
    'Write what you need, and I will build it.',
    'Which idea will not let you rest?',
    'What are we building for your business this time?',
    'A showcase site, a store or a system?',
    'What does your dream app look like?',
    'What are we adding to the project today?',
    'Let us keep it simple: what would you like to build?',
    'Which design would reflect your brand?',
    'What are your customers looking for?',
    'Which idea shall we test today?',
    'What would look amazing on a phone too?',
    'Have a photo or a sketch? We can start from it.',
    'Which project are we working on together?',
    'What would you like to show the world?',
    'Let us build the first version.',
    'Which idea becomes this week’s project?',
    'What would help you sell more?',
    'Which page would present your services best?',
    'What shall we teach the app to do?',
    'Which system would organize your work?',
    'Let us get going. What is the goal?',
    'How should people feel when they open your website?',
    'Which field are we building for today?',
    'What shall we build for your community?',
    'Which event, course or workshop are we promoting?',
    'What would you like to happen automatically?',
    'Which new feature are we building?',
    'What will your next project be?',
    'Let us build something that has never existed.',
    'What is the name of your next idea?',
    'How do we take your business digital?',
    'Which dashboard would bring you order?',
    'What shall we build for your customers?',
    'Have a few minutes? That is enough to start.',
    'What would you build if anything were possible?',
    'What should your website say at first glance?',
    'Which app would save you phone calls?',
    'Let us make your business stand out.',
    'What are we preparing for the next launch?',
    'Which digital product are we building?',
    'What would you like to build before the day ends?',
    'Where will your idea meet its customers?',
    'Which business dream are we moving forward today?',
    'What shall we improve on your current website?',
    'Let us build something fast, beautiful and useful.',
    'Which question will your app answer?',
    'What should customers be able to do in one tap?',
    'Which idea gets a fresh new design?',
    'What project have you always wanted to build?',
    'Which service are we presenting online today?',
    'Shall we begin? Tell me what we are building.',
    'Which portfolio shall we build for you?',
    'What would make customers come back?',
    'Which app would make your day easier?',
    'What shall we build for your team?',
    'Let us turn the idea into a click.',
    'Which website would make you proud?',
    'What would you like to try out for real?',
    'Which project are we taking out of the drawer today?',
    'What shall we build for your brand?',
    'Which first screen will greet your users?',
    'What is the most important thing the website must do?',
    'Which process shall we automate?',
    'Let us build it together, step by step.',
    'What would you like to launch this month?',
    'Which list, board or calendar shall we build?',
    'What shall we build for your next customer?',
    'Which idea will start the week with momentum?',
    'What would you like your phone to be able to do?',
    'Let us build something that works from day one.',
    'Have a vision? Let us build it.'
  ]
};

export const GREETING_COUNT = 120;

/** The inspiration line for an index, in the active language (falls back to Hebrew, then index 0). */
export function greetingText(index, locale = 'he') {
  const list = GREETINGS[locale] || GREETINGS.he;
  const safe = Number.isInteger(index) && index >= 0 && index < list.length ? index : 0;
  return list[safe];
}
